<template>
  <div class="container">
    <div class="list-brand-card" v-for="item in couponBrandList">
      <i
        class="el-icon-error activeDelBtn"
        @click.stop="removeCouponBrand(item)"
      ></i>
      <p>{{ item.brandName }}</p>
    </div>
    <el-card
      class="add-btn"
      shadow="never"
      body-style="padding: 0"
      @click.native="addHandler"
    >
      <i class="el-icon-plus"></i>
    </el-card>

    <el-dialog
      title="添加商品"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      v-loading="dialogLoading"
    >
      <el-select
        v-model="brandData"
        multiple
        filterable
        remote
        reserve-keyword
        placeholder="请输入品牌名称"
        :remote-method="searchBrand"
        :loading="brandLoading"
        style="width: 100%"
      >
        <el-option
          v-for="item in brandList"
          :key="item.brandId"
          :label="item.brandName"
          :value="item.brandId"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        style="margin-top: 20px;"
        @click="addNewCouponBrand"
        >保存</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import inputTag from "./inputTag";
import {
  getCouponBrandApi,
  saveCouponBrandApi,
  delCouponBrandApi
} from "@/api/coupon";
import { selectAllBrand } from "@/api/api";
export default {
  name: "couponBrand",
  components: { inputTag },
  props: {
    couponId: {
      required: true,
      type: Number | String
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      brandLoading: false,
      couponBrandList: [],
      brandList: [],
      brandData: []
    };
  },
  watch: {
    couponId: function(v) {
      if (v) {
        this.loadCouponBrand();
      } else {
        this.couponBrandList = [];
      }
    }
  },
  created() {},
  methods: {
    addHandler() {
      if (!this.couponId) {
        this.$message({
          message: "请先保存基础信息后在添加",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
    },
    loadCouponBrand() {
      let _self = this;
      if (this.couponId) {
        getCouponBrandApi(this.couponId).then(res => {
          if (res.data.status == 100) {
            _self.couponBrandList = res.data.results;
          }
        });
      }
    },
    searchBrand(query) {
      if (query !== "") {
        console.log(query);
        this.brandLoading = true;
        selectAllBrand({ brandName: query })
          .then(res => {
            if (res.data.status == 100) {
              this.brandList = res.data.results;
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            this.brandLoading = false;
          });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.brandData = [];
    },
    addNewCouponBrand() {
      if (this.brandData && this.brandData.length > 0) {
        this.saveCouponBrand();
      } else {
        this.$message({ message: "请确认需要添加的型号", type: "warning" });
      }
    },
    saveCouponBrand() {
      let _self = this;
      if (this.brandData && this.brandData.length > 0 && this.couponId) {
        _self.dialogLoading = true;
        saveCouponBrandApi(this.couponId, this.brandData)
          .then(res => {
            if (res.data.status == 100) {
              _self.loadCouponBrand();
              _self.handleClose();
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            _self.dialogLoading = false;
          });
      }
    },
    removeCouponBrand(item) {
      let _self = this;
      if (item && item.id) {
        this.$confirm(`是否删除当前型号${item.brandName}`, "提示", {
          type: "warning"
        })
          .then(() => {
            delCouponBrandApi(item.id).then(res => {
              if (res.data.status == 100) {
                _self.loadCouponBrand();
                _self.handleClose();
              } else {
                this.$message({ message: res.data.message, type: "warning" });
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="scss" type="text/css" scoped>
.container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.list-brand-card {
  align-items: center;
  justify-content: center;
  display: flex;

  position: relative;
  width: 200px;
  height: 80px;
  margin: 0 20px;
  margin-top: 10px;
  border: 1px solid #c6c6c6;
  border-radius: 20px;
  padding: 10px;
  .activeDelBtn {
    display: none;
    position: absolute;
    top: 5px;
    left: 5px;
    color: #c41335;
  }
  &:hover .activeDelBtn {
    display: block;
  }
}
.add-btn {
  width: 50px;
  height: 50px;
  border: 1px dashed #c6c6c6;
  line-height: 50px;
  display: flex;
  justify-content: center;
  i {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// couponBrand.vue?3b48ca42